import React from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import type { ZodiacSign } from './types';

interface HoroscopeCardProps {
  sign: ZodiacSign;
  onPrev: () => void;
  onNext: () => void;
}

export const HoroscopeCard: React.FC<HoroscopeCardProps> = ({
  sign,
  onPrev,
  onNext,
}) => {
  return (
    <div className="bg-white/10 backdrop-blur-lg p-6 rounded-lg animate-float">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-purple-200 flex items-center">
            <Star className="w-5 h-5 mr-2 text-yellow-400" />
            {sign.name}
          </h3>
          <span className="text-sm text-purple-300">
            {sign.date}
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={onPrev}
            className="p-1 hover:bg-white/10 rounded-full transition-colors"
            aria-label="Signo anterior"
          >
            <ChevronLeft className="w-5 h-5 text-purple-300" />
          </button>
          <button
            onClick={onNext}
            className="p-1 hover:bg-white/10 rounded-full transition-colors"
            aria-label="Próximo signo"
          >
            <ChevronRight className="w-5 h-5 text-purple-300" />
          </button>
        </div>
      </div>

      <div className="space-y-4">
        <p className="text-purple-200/80 text-sm">{sign.prediction}</p>
        
        <div className="flex items-center justify-between text-xs text-purple-300/70">
          <span>Número da Sorte: {sign.luckyNumber}</span>
          <button 
            onClick={onNext}
            className="text-purple-300 hover:text-purple-200 transition-colors"
          >
            Ver próximo signo
          </button>
        </div>
      </div>
    </div>
  );
};